import React from 'react';
import { Box, Typography, color, Flex, Button } from '@kistech/kis-ui';
import { Requirements } from './VideoRequirements';

interface VideoMediaDetailsProps {
  mediaType?: string;
  video?: string;
  error: string | null;
  onAddVideoClick: () => void;
  onVideoDelete: () => void;
  isLoading: boolean;
}

export const VideoMediaDetails: React.FC<VideoMediaDetailsProps> = (props: VideoMediaDetailsProps) => {
  const { video, mediaType, error, onAddVideoClick, onVideoDelete, isLoading } = props;
  return (
    <Box>
      <Typography size={18}>File Details</Typography>
      <Typography size={14}>Name: {video}</Typography>
      <Box margin="6 0" />
      <Requirements videoType={mediaType} />
      {error && (
        <Box margin="3 0">
          <Typography size={16} color={color.RED}>
            {error}
          </Typography>
        </Box>
      )}
      <Flex direction="row" align="center" gutter={2}>
        <Button
          size="x-small"
          width={200}
          appearance="primary"
          onClick={onAddVideoClick}
          isLoading={isLoading}
          data-testid="add-video-button"
        >
          Select Different Video
        </Button>
        <Button
          size="x-small"
          width={200}
          appearance="white"
          onClick={onVideoDelete}
          isLoading={isLoading}
          data-testid="delete-video-button"
        >
          Delete
        </Button>
      </Flex>
    </Box>
  );
};
